/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:40:59AM]
Permissions to update outside the main branch: [false]
*/

import { sharpDateFormatter } from '@finbeat/react-toolkit';
import { useGeneralSettingsContext } from 'providers/GeneralSettingsProvider';
import { useTranslation } from 'react-i18next';

type DataTimeProps = { value: string | null | undefined; format?: string | null };

const DataTimeText = ({ value, format }: DataTimeProps) => {
    useTranslation();
    const { dateTimeFormat } = useGeneralSettingsContext();
    return <>{sharpDateFormatter(value, format ?? dateTimeFormat)}</>;
};

export default DataTimeText;
